import request from '@/utils/request'
// 先用新闻代替
// 获取解决方案类型
export function getSolve (data) {
  console.log(process.env.NODE_ENV)
  return request({
    url: '/SolutionApi/SolutionTypeIndex',
    method: 'post',
    data
  })
}
// 获取解决方案类型中心
export function getSolveList (data) {
  return request({
    url: '/SolutionApi/Index',
    method: 'post',
    data
  })
}
// 获取解决方案详情
export function getSolveShow (data) {
  return request({
    url: '/SolutionApi/Show',
    method: 'post',
    data
  })
}
